import { render, staticRenderFns } from "./OdontogramaOdt.vue?vue&type=template&id=3dbd7a8c&scoped=true"
import script from "./OdontogramaOdt.vue?vue&type=script&lang=js"
export * from "./OdontogramaOdt.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaOdt.vue?vue&type=style&index=0&id=3dbd7a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd7a8c",
  null
  
)

export default component.exports